import { Component, Input, OnInit, ViewChildren } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzUploadFile } from 'ng-zorro-antd/upload';
import { Observable, Observer } from 'rxjs';
import { FolkService } from '@ascschool/services/school/folk.service';
import { UtilsService } from '@ascschool/services/utils.service';
import { Staff } from '@ascschool/model/user/staff.model';
import { map } from 'rxjs/operators';
import { PersonnelStatusService } from '@ascschool/services/category/personnel-status.service';
import { NationnalityService } from '@ascschool/services/category/nationnality.service';
import { PositionService } from '@ascschool/services/category/position.service';
import { ContractTypeService } from '@ascschool/services/category/contract-type.service';
import { SubjectService } from '@ascschool/services/school/subject.service';
import { QualificationService } from '@ascschool/services/category/qualification.service';
import { MajorService } from '@ascschool/services/category/major.service';
import { ProvinceService } from '@ascschool/services/category/province.service';
import { DistrictService } from '@ascschool/services/category/district.service';
import { WardService } from '@ascschool/services/category/ward.service';
import { CertificateOfStaff } from '@ascschool/model/user/certificate-of-staff.model';
import { StaffService } from '@ascschool/services/user/staff.service';
import { DiplomasService } from '@ascschool/services/category/diplomas.service';
import { Province } from '@ascschool/model/category/province.model';
import { District } from '@ascschool/model/category/district.model';
import { Ward } from '@ascschool/model/category/ward.model';
import { Folk } from '@ascschool/model/school/folk.model';
import { Nationality } from '@ascschool/model/category/nationality.model';
import { DisPosition } from '@ascschool/model/category/position.model';
import { Subject } from '@ascschool/model/school/subject.model';
import { Qualification } from '@ascschool/model/category/qualification.model';
import { Major } from '@ascschool/model/category/major.model';
import * as _ from 'lodash';
@Component({
  selector: 'app-xem-can-bo-quan-ly',
  templateUrl: './xem-can-bo-quan-ly.component.html',
  styleUrls: ['./xem-can-bo-quan-ly.component.scss']
})
export class XemCanBoQuanLyComponent implements OnInit {
  @Input() value: any;
  @Input() EducationAndTrainingOrSchoolId;
  @Input() typeOfPersonnel: number;
  @ViewChildren("label") labelElement;
  listCertification: CertificateOfStaff[] = [];
  dataCertification = [];
  gender = 1;
  PersonnelstatusSubscription: any;
  loadingChungChi = false;
  isNoteFolk : boolean;
  validateForm = new FormGroup({
    id: new FormControl('', Validators.required), typeOfPersonnel: new FormControl('', Validators.required),
    formType: new FormControl(''), provinceCode: new FormControl(''), ministryCode: new FormControl(''),
    yearManager: new FormControl('', Validators.required), employmentStatusId: new FormControl('', Validators.required),
    educationAndTrainingOrSchoolId: new FormControl('', Validators.required), yearsOfService: new FormControl(''),
    fullName: new FormControl('', Validators.required), gender: new FormControl(this.gender, Validators.required),
    yearOfBirth: new FormControl(null, Validators.required), folkId: new FormControl('', Validators.required),
    nationalityId: new FormControl('', Validators.required), positionId: new FormControl('', Validators.required),
    contractTypeId: new FormControl(''), qualificationId: new FormControl('', Validators.required),
    majorId: new FormControl(''), idNumber: new FormControl(''), issuedBy: new FormControl(''),folk: new FormControl(''),
    idNumberDate: new FormControl(''), phoneNumber: new FormControl(''), email: new FormControl(''),
    provinceId: new FormControl(''), districtId: new FormControl(''), wardId: new FormControl(''),
    staffCode: new FormControl(''), avartar: new FormControl(''), staffUnfostered: new FormControl(null),
    listCertificateOfStaff: new FormControl([]), listDisStaffTeachingAndSupports: new FormControl([]),
    listDisStaffTrainingAndRetrainings: new FormControl([]), listDisStaffParticipationModes: new FormControl([]),
    token: new FormControl(''), stt: new FormControl(null), isCoordinationAsfac: new FormControl(null),
    coordinationAsfacId: new FormControl(null), yearsOfTeaching: new FormControl(null),positionGVId: new FormControl(''),position: new FormControl(''),
  });
  getFolkACFn: (value: any) => Observable<any>;
  FolkSubscription: any;
  FolkControl = this.validateForm.controls.folkId;
  getPersonnelstatusACFn: (value: any) => Observable<any>;
  EmploymentStatusIdControl = this.validateForm.controls.employmentStatusId;
  getnatioNalityACFn: (value: any) => Observable<any>;
  natioNalitySubscription: any;
  natioNalityControl = this.validateForm.controls.nationalityId;
  getTypeofPersonnelACFn: (value: any) => Observable<any>;
  TypeofPersonnelSubscription: any;
  // TypeofPersonnelControl = this.validateForm.controls.typeOfPersonnelId;
  getPositionACFn: (value: any) => Observable<any>;
  PositionSubscription: any;
  PositionControl = this.validateForm.controls.positionId;
  getContractTypeACFn: (value: any) => Observable<any>;
  ContractTypeSubscription: any;
  ContractTypeControl = this.validateForm.controls.contractTypeId;
  getSubjectACFn: (value: any) => Observable<any>;
  SubjectSubscription: any;
  SubjectControl = this.validateForm.controls.subjectId;
  getSubSubjectACFn: (value: any) => Observable<any>;
  SubjectSubSubscription: any;
  SubSubjectControl = this.validateForm.controls.subSubjectId;
  getSchoolLevelACFn: (value: any) => Observable<any>;
  SchoolLevelSubscription: any;
  // SchoolLevelControl = this.validateForm.controls.schoolLevelId;
  getQualificationACFn: (value: any) => Observable<any>;
  QualificationSubscription: any;
  QualificationControl = this.validateForm.controls.qualificationId;
  getMajorACFn: (value: any) => Observable<any>;
  MajorSubscription: any;
  MajorControl = this.validateForm.controls.majorId;
  getRankACFn: (value: any) => Observable<any>;
  RankSubscription: any;
  // RankControl = this.validateForm.controls.rankId;
  // getDegreeACFn: (value: any) => Observable<any>;
  // DegreeSubscription: any;
  // DegreeControl = this.validateForm.controls.degreeId;
  getProvinceACFn: (value: any) => Observable<any>;
  ProvinceSubscription: any;
  ProvinceControl = this.validateForm.controls.provinceId;
  getDistrictACFn: (value: any) => Observable<any>;
  DistrictSubscription: any;
  DistrictControl = this.validateForm.controls.districtId;
  getWardACFn: (value: any) => Observable<any>;
  WardSubscription: any;
  WardControl = this.validateForm.controls.wardId;
  getVillageACFn: (value: any) => Observable<any>;
  VillageSubscription: any;
  VillageControl = new FormControl();
  listDiploma: ({
    value: number;
    name: string;
    checked: boolean;
  })[] = [];
  listDiplomaSelect: number[] = [];
  staffUnfosteredChecked : any;
  loading = false;
  avatarUrl?: string;
  staff = new Staff();
  isEditMode: boolean;
  currentUser: any;
  urlUploadAvt: string;
  constructor(
    private modal: NzModalRef, private msg: NzMessageService, private folkService: FolkService,
    public utilService: UtilsService, private personnelstatusService: PersonnelStatusService,
    private nationnalityService: NationnalityService, private positionService: PositionService,
    private contractTypeService: ContractTypeService, private subjectService: SubjectService,
    private qualificationService: QualificationService, private majorService: MajorService,
    private provinceService: ProvinceService, private districtService: DistrictService,
    private wardService: WardService, private staffService: StaffService,
    private untilSearvice: UtilsService, private diplomasService: DiplomasService,
  ) {
  }

  ngOnInit() {
    this.currentUser = JSON.parse(localStorage.getItem('userSetting'));
    this.urlUploadAvt = this.staffService.getUrlImportAvatar();
    this.validateForm.controls.typeOfPersonnel.setValue(this.typeOfPersonnel);
    this.getDefaultValue();
    this.loadFolk();
    this.loadPersonnelstatus();
    this.loadnatioNality();
    this.loadPosition();
    this.loadContractType();
    this.loadQualification();
    this.loadMajor();
    this.loadProvince();
    this.loadDiploma();
    this.staffUnfosteredChange();
    if (this.value && this.value.id > 0) {
      if (this.currentUser.accountType !== 3) {
        this.GetById(this.value.id);
      } else {
        this.GetSelectPagingById(this.value.id);
      }
      this.isEditMode = true;
    } else {
      this.staff = new Staff();
      this.isEditMode = false;
    }
  }
  GetSelectPagingById(id: number) {
    this.staffService.getById(id).subscribe((res) => {
      if (res && res.avartar) {
        this.staffService.getImage(res.avartar).subscribe((img) => {
          if (img.img) {
            this.cardImageBase64 = 'data:image/jpg;base64,' + img.img;
            this.isImageSaved = true;
          }
        });
      }
      this.validateForm.setValue(res);
      if (res.provinceId) {
        this.provinceService.getSelectPagingProvinceById(res.provinceId).subscribe((pro: Province) => {
          this.ProvinceControl.setValue({ id: pro.id, text: pro.provinceName });
          if (res.districtId) {
            this.loadDistrict();
            this.districtService.getSelectPagingDistrictById(res.districtId).subscribe((dis: District) => {
              this.DistrictControl.setValue({ id: dis.id, text: dis.districtName });
              if (res.wardId) {
                this.loadWard();
                this.wardService.getSelectPagingWardById(res.wardId).subscribe((war: Ward) => {
                  this.WardControl.setValue({ id: war.id, text: war.wardName });
                });
              }
            });
          }
        });
      }
      if (res.contractTypeId) {
        this.contractTypeService.getSelectById(res.contractTypeId).subscribe((res) => {
          this.ContractTypeControl.setValue({ id: res.id, text: res.name });
        });
      }

      if (res.folkId) {
        this.folkService.getSelectPagingFolkById(res.folkId).subscribe((fol: Folk) => {
          this.FolkControl.setValue({ id: fol.id, text: fol.folkName });
          this.isNoteFolk = fol.isNote;
        });
      }
      if (res.employmentStatusId) {
        this.personnelstatusService.getSelectPagingPersonnelStatusById(res.employmentStatusId).subscribe((rel) => {
          this.EmploymentStatusIdControl.setValue({ id: rel.id, text: rel.name })
        });
      }
      if (res.nationalityId) {
        this.nationnalityService.getSelectPagingNationnalityById(res.nationalityId).subscribe((nat: Nationality) => {
          this.natioNalityControl.setValue({ id: nat.id, text: nat.nationalityName })
        });
      }
      if (res.listDisStaffTeachingAndSupports) {

      }
      if (res.positionId) {
        this.positionService.getSelectPagingById(res.positionId).subscribe((pos: DisPosition) => {
          this.PositionControl.setValue({ id: pos.id, text: pos.positionName })
        });
      }

      if (res.subjectId) {
        this.subjectService.getSelectPagingSubjectsById(res.subjectId).subscribe((sub: Subject) => {
          this.SubjectControl.setValue({ id: sub.id, text: sub.subjectName })
        });
      }
      if (res.qualificationId) {
        this.qualificationService.getSelectPagingById(res.qualificationId).subscribe((qua: Qualification) => {
          this.QualificationControl.setValue({ id: qua.id, text: qua.qualificationName })
        });
      }

      if (res.majorId) {
        this.majorService.getSelectPagingById(res.majorId).subscribe((maj: Major) => {
          this.MajorControl.setValue({ id: maj.id, text: maj.majorName })
        });
      }
      //Checked
      if (res.listCertificateOfStaff.length > 0) {
        this.listDiplomaSelect = res.listCertificateOfStaff;
        // res.listCertificateOfStaff.forEach(id => {
        //   this.listDiploma.forEach(value => {
        //     if (id === value.value) {
        //       value.checked = true;
        //     }
        //   });
        // });
      }
    });
  }
  GetById(id: number) {
    this.staffService.getById(id).subscribe((res) => {
      if (res && res.avartar) {
        this.staffService.getImage(res.avartar).subscribe((img) => {
          if (img.img) {
            this.cardImageBase64 = 'data:image/jpg;base64,' + img.img;
            this.isImageSaved = true;
          }
        });
      }
      this.validateForm.setValue(res);
      if (res.provinceId) {
        this.provinceService.getSelectPagingProvinceById(res.provinceId).subscribe((pro: Province) => {
          this.ProvinceControl.setValue({ id: pro.id, text: pro.provinceName });
          if (res.districtId) {
            this.loadDistrict();
            this.districtService.getSelectPagingDistrictById(res.districtId).subscribe((dis: District) => {
              this.DistrictControl.setValue({ id: dis.id, text: dis.districtName });
              if (res.wardId) {
                this.loadWard();
                this.wardService.getSelectPagingWardById(res.wardId).subscribe((war: Ward) => {
                  this.WardControl.setValue({ id: war.id, text: war.wardName });
                });
              }
            });
          }
        });
      }

      if (res.wardId) {
        this.wardService.getSelectPagingWardById(res.wardId).subscribe((war: Ward) => {
          this.WardControl.setValue({ id: war.id, text: war.wardName })
        });
      }

      if (res.folkId) {
        this.folkService.getSelectPagingFolkById(res.folkId).subscribe((fol: Folk) => {
          this.FolkControl.setValue({ id: fol.id, text: fol.folkName });
          this.isNoteFolk = fol.isNote;
        });
      }

      if (res.nationalityId) {
        this.nationnalityService.getSelectPagingNationnalityById(res.nationalityId).subscribe((nat: Nationality) => {
          this.natioNalityControl.setValue({ id: nat.id, text: nat.nationalityName })
        });
      }

      if (res.employmentStatusId) {
        this.personnelstatusService.getSelectPagingPersonnelStatusById(res.employmentStatusId).subscribe((rel) => {
          this.EmploymentStatusIdControl.setValue({ id: rel.id, text: rel.name })
        });
      }
      if (res.contractTypeId) {
        this.contractTypeService.getSelectById(res.contractTypeId).subscribe((res) => {
          this.ContractTypeControl.setValue({ id: res.id, text: res.name });
        });
      }
      if (res.positionId) {
        this.positionService.getSelectPagingById(res.positionId).subscribe((pos: DisPosition) => {
          this.PositionControl.setValue({ id: pos.id, text: pos.positionName })
        });
      }

      if (res.subjectId) {
        this.subjectService.getSelectPagingSubjectsById(res.subjectId).subscribe((sub: Subject) => {
          this.SubjectControl.setValue({ id: sub.id, text: sub.subjectName })
        });
      }

      if (res.subSubjectId) {
        this.subjectService.getSelectPagingSubjectsById(res.subSubjectId).subscribe((sub: Subject) => {
          this.SubSubjectControl.setValue({ id: sub.id, text: sub.subjectName })
        });
      }

      if (res.qualificationId) {
        this.qualificationService.getSelectPagingById(res.qualificationId).subscribe((qua: Qualification) => {
          this.QualificationControl.setValue({ id: qua.id, text: qua.qualificationName })
        });
      }

      if (res.majorId) {
        this.majorService.getSelectPagingById(res.majorId).subscribe((maj: Major) => {
          this.MajorControl.setValue({ id: maj.id, text: maj.majorName })
        });
      }
      //load checked diploma
      if (res.listCertificateOfStaff.length > 0) {
        this.listDiplomaSelect = res.listCertificateOfStaff;
        // res.listCertificateOfStaff.forEach(id => {
        //   this.listDiploma.forEach(value => {
        //     if (id === value.value) {
        //       value.checked = true;
        //     }
        //   });
        // });
      }
    });
  }
  getDefaultValue() {
    this.folkService.getSelectPagingDefault().subscribe((res) => {
      if (res != null) {
        this.FolkControl.setValue({ id: res.id, text: res.folkName });
        this.staff.folkId = res.id;
      }
    });
    this.nationnalityService.getSelectPagingDefault().subscribe((res) => {
      if (res != null) {
        this.natioNalityControl.setValue({ id: res.id, text: res.nationalityName });
        this.staff.nationalityId = res.id;
      }
    });
    // this.validateForm.controls.staffCertificated.setValue(false);
    // this.validateForm.controls.staffLicensed.setValue(false);
    // this.validateForm.controls.staffUnfostered.setValue(false);
  }
  Update(close: Boolean) {
    if (this.currentUser.accountType === 6 || this.currentUser.accountType === 5 || this.currentUser.accountType === 1) {
      if (this.EducationAndTrainingOrSchoolId) {
        this.validateForm.controls.educationAndTrainingOrSchoolId.setValue(this.EducationAndTrainingOrSchoolId);
      } else {
        this.validateForm.controls.educationAndTrainingOrSchoolId.setValue(this.currentUser.eadId);
      }
    } else {
      this.validateForm.controls.educationAndTrainingOrSchoolId.setValue(this.currentUser.eadId);
    }
    let listIdDiploma = [];
    let listCheckedDiploma = [];
    listIdDiploma = this.listDiploma;
    listIdDiploma.forEach(value => {
      if (value.checked) {
        listCheckedDiploma.push(value.value);
      }
    });
    this.validateForm.controls.listCertificateOfStaff.setValue(listCheckedDiploma);
    if (this.validateForm.valid) {
      // this.validateForm.value.staffCode = 'string';
      this.staffService.addOrUpdate(this.setToId(this.validateForm)).subscribe((res) => {
        if (res.statusCode === 0) {
          this.notification(res);
          if (close == true) {
            this.modal.close(true);
          } else {
            this.validateForm.reset();
            this.validateForm.controls.gender.setValue(this.gender);
            this.getDefaultValue();
            this.listCertification = [];
          }
        } else {
          this.notification(res);
        }
      });
    } else {
      this.untilSearvice.showNotifyInvalidControls(this.validateForm, this.labelElement);
    }
  }
  setToId(formGroup: FormGroup): Staff {
    const formValue = formGroup.value;
    Object.entries(formValue).forEach(element => {
      const [key, value]: any = element;
      if (typeof value === 'object' && value !== null && value !== undefined) {
        if (value.id) {
          formValue[key] = value.id;
        }
      }
    });
    // if (formValue.salaryRatio === '' || formValue.salaryRatio === null){
    //   delete formValue.salaryRatio;
    // }
    return formValue;
  }
  close(e: MouseEvent) {
    e.preventDefault();
    this.destroyModal();
  }
  destroyModal(): void {
    this.modal.destroy(true);
  }
  //upload image
  beforeUpload = (file: NzUploadFile, _fileList: NzUploadFile[]) => {
    return new Observable((observer: Observer<boolean>) => {
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
      if (!isJpgOrPng) {
        this.msg.error('Bạn chỉ upload được JPG file!');
        observer.complete();
        return;
      }
      const isLt2M = file.size! / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.msg.error('Hình ảnh chỉ nhỏ hơn 2MB!');
        observer.complete();
        return;
      }
      this.staffService.importAvata(file).subscribe(res => {
        if (res.length > 0) {
          this.staff.avartar = res[res.length - 1].filePath;
          observer.next(true);
        }
      });
      observer.complete();
    });
  };

  private getBase64(img: File, callback: (img: string) => void): void {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result!.toString()));
    reader.readAsDataURL(img);
  }

  handleChange(info: { file: NzUploadFile }): void {
    switch (info.file.status) {
      case 'uploading':
        this.loading = true;
        break;
      case 'done':
        // Get this url from response in real world.
        this.getBase64(info.file!.originFileObj!, (img: string) => {
          this.loading = false;
          this.avatarUrl = img;
        });
        break;
      case 'error':
        this.msg.error('Network error');
        this.loading = false;
        break;
    }
  }
  onChange(result: Date[]): void {
    console.log('onChange: ', result);
  }
  loadFolk() {
    this.getFolkACFn = (value: any) => this.folkService.getFolkSelectPaging({
      searchTerm: value, PageIndex: 1, PageSize: 100
    }).pipe(map(resp => resp.results.length > 0
      ? resp.results.map(x => ({ id: x.id, text: x.folkName, isNote: x.isNote })) : [{ id: null, text: 'Không có dữ liệu' }]));
    if (!this.FolkSubscription) {
      this.FolkSubscription = this.FolkControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(this.staff, 'folkId', this.FolkControl.value);
      });
    }
  }
  changeFolk(control: FormControl) {
    this.FolkControl = control;
    if(this.FolkControl){
      this.isNoteFolk = this.FolkControl.value.isNote;
    }
  }
  loadPersonnelstatus() {
    // tslint:disable-next-line: max-line-length
    this.getPersonnelstatusACFn = (value: any) => this.personnelstatusService.getPersonnelStatusSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.statusName })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.PersonnelstatusSubscription) {
      this.PersonnelstatusSubscription = this.EmploymentStatusIdControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(this.staff, 'employmentStatusId', this.EmploymentStatusIdControl.value);
      });
    }
  }
  changePersonnelstatus(control: FormControl) {
    this.EmploymentStatusIdControl = control;
  }
  loadnatioNality() {
    // tslint:disable-next-line: max-line-length
    this.getnatioNalityACFn = (value: any) => this.nationnalityService.getNationnalitySelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.nationalityName })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.natioNalitySubscription) {
      this.natioNalitySubscription = this.natioNalityControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(this.staff, 'nationalityId', this.natioNalityControl.value);
      });
    }
  }
  changenatioNality(control: FormControl) {
    this.natioNalityControl = control;
  }
  // loadTypeofPersonnel() {
  //   // tslint:disable-next-line: max-line-length
  //   this.getTypeofPersonnelACFn = (value: any) => this.typeofpersonnelService.getTypeOfPersonnelSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
  //     map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.typeOfPersonnelName })) : [{ id: null, text: 'Không có dữ liệu' }])
  //   );
  //   if (!this.TypeofPersonnelSubscription) { this.TypeofPersonnelSubscription = this.TypeofPersonnelControl.valueChanges.subscribe(() => {
  //     this.utilService.bindOrUnBindTheId(this.staff, 'typeOfPersonnelId', this.TypeofPersonnelControl.value);
  //   });
  //   }
  // }
  // changeTypeofPersonnel(control: FormControl) {
  //   this.TypeofPersonnelControl = control;
  // }
  loadPosition() {
    this.getPositionACFn = (value: any) => this.positionService.getSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.positionName })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.PositionSubscription) {
      this.PositionSubscription = this.PositionControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(this.staff, 'positionId', this.PositionControl.value);
      });
    }
  }
  changePosition(control: FormControl) {
    this.PositionControl = control;
  }
  loadContractType() {
    // tslint:disable-next-line: max-line-length
    this.getContractTypeACFn = (value: any) => this.contractTypeService.getSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.name })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.ContractTypeSubscription) {
      this.ContractTypeSubscription = this.ContractTypeControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(this.staff, 'contractTypeId', this.ContractTypeControl.value);
      });
    }
  }
  changeContractType(control: FormControl) {
    this.ContractTypeControl = control;
  }
  loadDiploma() {
    // tslint:disable-next-line: max-line-length
    this.diplomasService.getSelectPaging({ PageIndex: 1, PageSize: 100 }).subscribe(element => {
      this.listDiploma = element.results.map(x => ({ value: x.id, name: x.diplomaName, checked: false }));
    });
  }
  changeSubSubject(control: FormControl) {
    this.SubSubjectControl = control;
  }
  // loadSchoolLevel() {
  //   // tslint:disable-next-line: max-line-length
  //   this.getSchoolLevelACFn = (value: any) => this.schoollevelService.getSchoolLevelsSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
  //     map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.schoolLevelName })) : [{ id: null, text: 'Không có dữ liệu' }])
  //   );
  //   if (!this.SchoolLevelSubscription) { this.SchoolLevelSubscription = this.SchoolLevelControl.valueChanges.subscribe(() => {
  //     this.utilService.bindOrUnBindTheId(this.staff, 'schoolLevelId', this.SchoolLevelControl.value);
  //   });
  //   }
  // }
  // changeSchoolLevel(control: FormControl) {
  //   this.SchoolLevelControl = control;
  // }
  loadQualification() {
    // tslint:disable-next-line: max-line-length
    this.getQualificationACFn = (value: any) => this.qualificationService.getSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.qualificationName })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.QualificationSubscription) {
      this.QualificationSubscription = this.QualificationControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(this.staff, 'qualificationId', this.QualificationControl.value);
      });
    }
  }
  changeQualification(control: FormControl) {
    this.QualificationControl = control;
  }
  loadMajor() {
    this.getMajorACFn = (value: any) => this.majorService.getSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      // tslint:disable-next-line: max-line-length
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.majorName })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.MajorSubscription) {
      this.MajorSubscription = this.MajorControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(this.staff, 'majorId', this.MajorControl.value);
      });
    }
  }
  changeMajor(control: FormControl) {
    this.MajorControl = control;
  }
  // loadRank() {
  //   this.getRankACFn = (value: any) => this.rankService.getSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
  //     // tslint:disable-next-line: max-line-length
  //     map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.rankName })) : [{ id: null, text: 'Không có dữ liệu' }])
  //   );
  //   if (!this.RankSubscription) { this.RankSubscription = this.RankControl.valueChanges.subscribe(() => {
  //     this.utilService.bindOrUnBindTheId(this.staff, 'rankId', this.RankControl.value);
  //   });
  //   }
  // }
  // changeRank(control: FormControl) {
  //   this.RankControl = control;
  // }
  // loadDegree() {
  //   this.getDegreeACFn = (value: any) => this.degreeService.getSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
  //     map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.degreeName })) : [{ id: null, text: 'Không có dữ liệu' }])
  //   );
  //   if (!this.DegreeSubscription) { this.DegreeSubscription = this.DegreeControl.valueChanges.subscribe(() => {
  //     this.utilService.bindOrUnBindTheId(this.staff, 'degreeId', this.DegreeControl.value);
  //   });
  //   }
  // }
  // changeDegree(control: FormControl) {
  //   this.DegreeControl = control;
  // }
  loadProvince() {
    // tslint:disable-next-line: max-line-length
    this.getProvinceACFn = (value: any) => this.provinceService.getProvinceSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.provinceName })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.ProvinceSubscription) {
      this.ProvinceSubscription = this.ProvinceControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(this.staff, 'provinceId', this.ProvinceControl.value);
      });
    }
  }
  changeProvince(control: FormControl) {
    this.ProvinceControl = control;
    this.loadDistrict();
    this.DistrictControl.setValue(null);
  }
  valueIfHas(control: any) {
    if (control.value && typeof control.value !== 'string') { return control.value.id; }
    return '';
  }

  loadDistrict() {
    // tslint:disable-next-line: max-line-length
    this.getDistrictACFn = (value: any) => this.districtService.getDistrictSelectPaging({ searchTerm: value, ProvinceId: this.valueIfHas(this.ProvinceControl), PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.districtName })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.DistrictSubscription) {
      this.DistrictSubscription = this.DistrictControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(this.staff, 'districtId', this.DistrictControl.value);
      });
    }
  }
  changeDistrict(control: FormControl) {
    this.DistrictControl = control;
    this.loadWard();
    this.WardControl.setValue(null);
  }

  loadWard() {
    // tslint:disable-next-line: max-line-length
    this.getWardACFn = (value: any) => this.wardService.getWardSelectPaging({ searchTerm: value, DistrictId: this.valueIfHas(this.DistrictControl), PageIndex: 1, PageSize: 100 }).pipe(
      // tslint:disable-next-line: max-line-length
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.wardName })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.WardSubscription) {
      this.WardSubscription = this.WardControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(this.staff, 'wardId', this.WardControl.value);
      });
    }
  }
  changeWard(control: FormControl) {
    this.WardControl = control;
  }
  notification(response) {
    if (response.statusCode === 0) {
      this.msg.success('Cập nhật thông tin ' + response.message);
    } else {
      this.msg.error('Lỗi: ' + response.message);
    }
  }
  diplomaChange(event, index) {
    this.listDiploma[index].checked = event;
  }
  staffUnfosteredChange() {
    return this.validateForm.controls.staffUnfostered.valueChanges.subscribe(element => {
      this.staffUnfosteredChecked = element;
      // if (!element) {
      //   this.listDiploma.forEach(element => {
      //     element.checked = false;
      //   });
      // }
    });
  }
  ngOnDestroy() {
    this.staffUnfosteredChange().unsubscribe();
  }
  imageError: string;
  isImageSaved: boolean;
  cardImageBase64: string;

  fileChangeEvent(fileInput: any) {
    this.imageError = null;
    this.validateForm.value.avartar = null;
    if (fileInput.target.files && fileInput.target.files[0]) {
      // Size Filter Bytes
      const allowed_types = ['image/png', 'image/jpeg'];
      if (!_.includes(allowed_types, fileInput.target.files[0].type)) {
        this.imageError = 'Chỉ chấp nhận ảnh ( JPG | PNG )';
        return false;
      }
      const reader = new FileReader();
      reader.onload = (e: any) => {
        const image = new Image();
        image.src = e.target.result;
        image.onload = () => {
          // Resize the image using canvas
          var canvas = document.createElement('canvas');
          canvas.width = 100;
          canvas.height = 100;
          canvas.getContext('2d').drawImage(image, 0, 0, 100, 100);
          //Getting base64 string;
          var dataUrl = canvas.toDataURL('image/jpeg');
          //const imgBase64Path = e.target.result;
          this.cardImageBase64 = dataUrl;
          this.isImageSaved = true;
        };
      };

      reader.readAsDataURL(fileInput.target.files[0]);
    }
  }

  removeImage() {
    this.cardImageBase64 = null;
    this.validateForm.value.avartar = null;
    this.isImageSaved = false;
  }
}
